type DocumentShape = { readonly documentTypeId: number | null };

/** A document type produces at most one document per group. */
function hasUniqueDocumentTypes(value: readonly (readonly DocumentShape[])[]): boolean {
	const typeIds = value.flat().map((document) => document.documentTypeId);

	return new Set(typeIds).size === typeIds.length;
}

export default hasUniqueDocumentTypes;
